export const environment = {
  production: true,
  local: false,
  apiUrl: 'https://famulusaiapi.rrsolutionstest.it/api/v1',
};
